import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {cloneObject, getParam} from '../utils/utils';

import dsd from "../classes/clsDSD";
import { getVersion, addVersion, editVersion, deleteVersion } from '../utils/utilsVersion';

import { Trash } from 'react-bootstrap-icons';

class Version extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            isFailed: false
        };


        this.data = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `.`;


    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    setup(){

        let StateChange = {

            isLoaded:false,

            FormData: {
            },

            Version: null,
            idVersion: null,

            idAbout: null,
            type: null,

            onLoad: null,

            mode: null

        }

        StateChange.mode = getParam('mode', this.props);
        StateChange.idAbout = getParam('idAbout', this.props);

        if (StateChange.mode == 'new'){
            StateChange.Version = {};
            StateChange.isLoaded = true;
        }

        StateChange.idVersion = getParam('idVersion', this.props);
        if (StateChange.idVersion){
            StateChange.mode = 'edit';
        }

        if (getParam('onActioned', this.props)){
            StateChange.onActioned = getParam('onActioned', this.props);
        }
    
        if (getParam('type', this.props)){
            StateChange.type = getParam('type', this.props);
        }

        // For new mode, ensure type is in FormData
        if (StateChange.mode == 'new' && StateChange.type){
            StateChange.FormData.type = StateChange.type;
        }

        if (StateChange.idVersion){
            this.loadVersion(StateChange.idVersion);
        }

        this.setState(StateChange);
        
    }


    loadVersion(id){

        let StateChange = {};
        StateChange.Version = null;

        const onLoad = function(version){
            let StateChange = {};
            StateChange.Version = version;
            StateChange.isLoaded = true;
            StateChange.FormData = version;
            if (this.state.mode == "new"){
                StateChange.FormData.type = this.state.type;
            }
            this.setState(StateChange);
        }.bind(this);

        const onFail = function(e){
            this.setState({
                isFailed: true,
                errorMessage: e.message || 'Failed to load version'
            });
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getVersion(this.dsd, id, onLoad, onFail);
        }

        this.setState(StateChange);

        return;
        
    };

    handleButton(event) {
    
        let StateChange = {};

        switch (event.currentTarget.name){
            case 'btnDelete':
                const onSuccess = function(){
                    if (this.state.onActioned){
                        this.state.onActioned();
                    }
                }.bind(this);

                const onError = function(e){
                    this.setState({
                        isFailed: true,
                        errorMessage: e.message || 'Failed to delete version'
                    });
                }.bind(this);

                deleteVersion(this.dsd, this.state.idVersion, onSuccess, onError);
                break;
    
        }
    
        this.setState(StateChange);
    
        event.preventDefault();    

    };


    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;

        this.setState({"FormData": FormData});

    };


    handleSubmit(event) {

        switch (event.target.name){
            
            case 'btnCancel':
        
                if (this.state.onActioned){
                    this.state.onActioned();
                }
    

                break;

            case 'btnSave':
    
                this.update();
        
                break;
    
        };
    }

    update(){    

        if (!this.state.isLoaded){
            return false;
        }

        const onError = function(e){
            let StateChange = {};
            StateChange.isFailed = true;
            StateChange.isError = true;
            StateChange.errorMessage = e.message || 'Failed to save version';

            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                    if (e.response.data.fields){
                        StateChange.invalidFields = e.response.data.fields;
                    }
                }
            }

            this.setState(StateChange);
            return;
        }.bind(this);

        switch (this.state.mode){
            case 'new':
                const onAdd = function(idVersion){
                    if (this.state.onActioned){
                        this.state.onActioned();
                    } else {
                        let StateChange = {};
                        StateChange.idVersion = idVersion;
                        StateChange.mode = 'view';
                        StateChange.loadData = true;
                        this.setState(StateChange);
                    }
                    return;
                }.bind(this);

                addVersion(this.dsd, this.state.idAbout, this.state.FormData, onAdd, onError);
                break;
            case 'edit':
                const onUpdate = function(){
                    if (this.state.onActioned){
                        this.state.onActioned();
                    } else {
                        let StateChange = {};
                        StateChange.mode = 'view';
                        StateChange.loadData = true;
                        this.setState(StateChange);
                    }
                    return;
                }.bind(this);

                editVersion(this.dsd, this.state.idVersion, this.state.FormData, onUpdate, onError);
                break;
            default:
                return false;
        };

        return true;

    }

    render() {

        if (this.state.isFailed) {
            return <PD.ErrorBox>ERROR - Failed to Load</PD.ErrorBox>
        }
        if (this.state.isError) {
            return <PD.ErrorBox>ERROR - Failed to Load</PD.ErrorBox>
        }

        if (this.state.isLoaded) {

            switch (this.state.mode){
                case 'new':
                case 'edit':
                    return (
                        <fieldset>
                            <legend>Version:</legend>
                            <PD.Input label="Name" width="40" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>
                            <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>

                            <div>
                                <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                            </div>

                        </fieldset>
                    );
                    break;
            };
        };

        return null;
    };
};

// Wrap and export
// with forwardref so that the update() method can be accessed.


export default React.forwardRef((props, ref) => {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Version ref={ref} {...props} navigation={navigation} location={location} params={params} />;
  }
);